export default [
  {
    path: '/',
    component: () => import('@views/auth/Login')
  },
  {
    path: '/login',
    component: () => import('@views/auth/Login')
  },
  {
    path: '/password',
    component: () => import('@views/auth/Password')
  },
  {
    path: '/auth/reset/:token',
    component: () => import('@views/auth/Reset')
  },
  {
    path: '/auth/email-verification/:token',
    component: () => import('@views/auth/EmailVerification')
  },
  {
    path: '/register',
    component: () => import('@views/auth/Register')
  }
]



// WEBPACK FOOTER //
// ./src/routers/guest.js